
import {
  defineComponent,
  toRefs,
  reactive,
  nextTick,
  ref
} from 'vue'


import { useRoute } from "vue-router";
export default defineComponent({
  components: {
  },
  emits: ['search'],
  setup(props, context) {
    const factorDataList = [
      {
      firstLevel: 1,
      key: 1,
      code: 'zf',
      name: '涨幅',
      children: [{
        parentKey: 2,
        parentCode: 'zf',
        parentName: '涨幅',
        prop: 'zf',
        key: '1-0',
        name: '大于2%',
        maxValue: '>',
        minValue: '2',
      },{
        parentKey: 2,
        parentCode: 'zf',
        parentName: '涨幅',
        prop: 'zf',
        key: '1-1',
        name: '大于5%',
        maxValue: '>',
        minValue: '5',
      },{
        parentKey: 2,
        parentCode: 'zf',
        parentName: '涨幅',
        prop: 'zf',
        key: '1-2',
        name: '小于-5%',
        maxValue: '<',
        minValue: '-5',
      },{
        parentKey: 2,
        parentCode: 'zf',
        parentName: '涨幅',
        prop: 'zf',
        key: '1-3',
        name: '小于-2%',
        maxValue: '<',
        minValue: '-2',
      },{
        parentKey: 2,
        parentCode: 'zf',
        parentName: '涨幅',
        prop: 'zf',
        type: 'custom',
        key: '1-4',
        name: '自定义',
        maxValue: '',
        minValue: '',
      }]
    },{
      firstLevel: 1,
      key: 2,
      code: 'hsl',
      name: '换手率',
      children: [{
        parentKey: 3,
        parentCode: 'hsl',
        parentName: '换手率',
        prop: 'pb',
        key: '2-1',
        name: '2%以下',
        maxValue: '<',
        minValue: '2'
      },{
        parentKey: 3,
        parentCode: 'hsl',
        parentName: '换手率',
        prop: 'pb',
        key: '2-2',
        name: '2%-5%',
        type: 'c',
        maxValue: '5',
        minValue: '2'
      },{
        parentKey: 3,
        parentCode: 'hsl',
        parentName: '换手率',
        prop: 'pb',
        key: '2-3',
        type: 'c',
        name: '5%-10%',
        maxValue: '10',
        minValue: '5'
      },{
        parentKey: 3,
        parentCode: 'hsl',
        parentName: '换手率',
        prop: 'pb',
        key: '2-4',
        name: '10%以上',
        maxValue: '>',
        minValue: '10'
      },{
        parentKey: 3,
        parentCode: 'hsl',
        parentName: '换手率',
        prop: 'pb',
        type: 'custom',
        key: '2-5',
        name: '自定义',
        maxValue: '',
        minValue: ''
      }]
    },{
      firstLevel: 1,
      key: 3,
      code: 'lzb',
      name: '连增榜',
      children: [{
        parentKey: 3,
        parentCode: 'lzb',
        parentName: '连增榜',
        prop: 'pb',
        key: '3-1',
        name: '3连增',
        maxValue: '=',
        minValue: '3'
      },{
        parentKey: 3,
        parentCode: 'lzb',
        parentName: '连增榜',
        prop: 'pb',
        key: '3-2',
        name: '5连增',
        maxValue: '=',
        minValue: '5'
      },{
        parentKey: 3,
        parentCode: 'lzb',
        parentName: '连增榜',
        prop: 'pb',
        type: 'custom',
        key: '3-3',
        name: '自定义',
        maxValue: '',
        minValue: ''
      }]
    },{
      firstLevel: 1,
      key: 4,
      code: 'ljb',
      name: '连降榜',
      children: [{
        parentKey: 3,
        parentCode: 'ljb',
        parentName: '连降榜',
        prop: 'pb',
        key: '4-1',
        name: '3连降',
        maxValue: '=',
        minValue: '3'
      },{
        parentKey: 3,
        parentCode: 'ljb',
        parentName: '连降榜',
        prop: 'pb',
        key: '4-2',
        name: '5连降',
        maxValue: '=',
        minValue: '5'
      },{
        parentKey: 3,
        parentCode: 'ljb',
        parentName: '连降榜',
        prop: 'pb',
        type: 'custom',
        key: '4-3',
        name: '自定义',
        maxValue: '',
        minValue: ''
      }]
    }]

    const route = useRoute();
    const itemRefs = ref(null);
    const sortTable = ref(null);

    const dataMap = reactive({
      formInline: {
        industryName: '',//行业名称
      },
      factorChildrenList: factorDataList[0].children as any,
      currentCheckValuetion: 'pettm',
      selectedIndustry: '',
      rangeCheckKeyList: ['pettm'], // 范围筛选的父级key集合
      // rangeCheckChildKeyList: ['2-2'], // 范围筛选的子集的key集合
      rangeCheckChildKeyList: [], // 范围筛选的子集的key集合
      rangeCheckList: [],
      // rangeCheckList: [{
      //   parentKey: 2,
      //   parentCode: 'pettm',
      //   parentName: 'PETTM(倍）',
      //   prop: 'peTtm',
      //   key: '2-0',
      //   name: '10-20',
      //   maxValue: 20,
      //   minValue: 10
      // }], // 范围筛选条件合集(默认综合估值10-20)
      industryActive: -1,
      page: {
        totalSize: 0,
        pageSize: 10,
        pageNum: 1,
      },
      page2: {
        totalSize: 0,
        pageSize: 10,
        pageNum: 1,
      },
      sortMap: {
        sortKey: 'peTtm',
        isAsc: true,
      },
      customValue1: '',
      customValue2: '',
      isVaild1: false,
      isVaild2: false,
      isDisabled: true,
    })

    // 删除行业
    const delIndustryTab = () => {
      dataMap.formInline.industryName = ''
      dataMap.selectedIndustry = ''
      dataMap.industryActive = -1
      dataMap.page.pageNum = 1
      dataMap.page2.pageNum = 1
      // fetchData()
    }

    // 选中范围子集
    const checkChildrenRange = (item:any) => {
      if(item.type === 'custom') return;
      const newArr = JSON.parse(JSON.stringify(dataMap.rangeCheckList)).filter((items:any) => items.parentCode !== item.parentCode).concat(item); 
      dataMap.rangeCheckList = newArr
      dataMap.rangeCheckKeyList = newArr.map((items:any) => items.parentCode);
      dataMap.rangeCheckChildKeyList = newArr.map((items:any) => items.key);
      const defaultSort = dataMap.rangeCheckList[0];
      // nextTick(() => {
      //   let { clearSort, sort } = sortTable.value as any;
      //   clearSort();
      //   sort(defaultSort['prop'], 'ascending');
      // })
      dataMap.sortMap = { sortKey: defaultSort ? defaultSort['prop'] : '',  isAsc: true }
      dataMap.page.pageNum = 1
      dataMap.page2.pageNum = 1
      // getDataList2()
    }

    // 删除范围子集
    const delChildrenRange = (item:any) => {
      const newArr = JSON.parse(JSON.stringify(dataMap.rangeCheckList)).filter((items:any) => items.parentCode !== item.parentCode); 
      dataMap.rangeCheckList = newArr
      dataMap.rangeCheckKeyList = newArr.map((items:any) => items.parentCode);
      dataMap.rangeCheckChildKeyList = newArr.map((items:any) => items.key);
      const defaultSort = dataMap.rangeCheckList[0];
      if(defaultSort) {
        // nextTick(() => {
        //   let { clearSort, sort } = sortTable.value as any;
        //   clearSort();
        //   sort(defaultSort['prop'], 'ascending');
        // })
        // dataMap.sortMap = { sortKey: defaultSort ? defaultSort['prop'] : '',  isAsc: true };
      }
      dataMap.page.pageNum = 1
      dataMap.page2.pageNum = 1
      // fetchData()
    }

    const saveCustomValue = (item:any) => {
      const newItem = {
        ...item,
        name: `${item.name}:[${dataMap.customValue1},${dataMap.customValue2}]`,
        maxValue: dataMap.customValue2,
        minValue: dataMap.customValue1
      }
      const newArr = JSON.parse(JSON.stringify(dataMap.rangeCheckList)).filter((items:any) => items.parentCode !== item.parentCode).concat(newItem); 
      dataMap.rangeCheckList = newArr
      dataMap.rangeCheckKeyList = newArr.map((items:any) => items.parentCode);
      dataMap.rangeCheckChildKeyList = newArr.map((items:any) => items.key);
      const defaultSort = dataMap.rangeCheckList[0];
      nextTick(() => {
        // let { clearSort, sort } = sortTable.value as any;
        // clearSort();
        // sort(defaultSort['prop'], 'ascending');
      })
      dataMap.customValue1 = '';
      dataMap.customValue2 = '';
      dataMap.isDisabled = true;
      dataMap.isVaild1 = false;
      dataMap.isVaild2 = false;
      nextTick(() => {
        // let obj = itemRefs.value as any;
        // obj.doDestroy();
        // obj.visibility = false
      })
      dataMap.sortMap = { sortKey: defaultSort ? defaultSort['prop'] : '',  isAsc: true }
      dataMap.page.pageNum = 1
      dataMap.page2.pageNum = 1
      // getDataList2() 
    }

    // 切换估值类型
    const changeFactorType = (item:any) => {
      dataMap.customValue1 = '';
      dataMap.customValue2 = '';
      dataMap.isDisabled = true;
      dataMap.isVaild1 = false;
      dataMap.isVaild2 = false;
      dataMap.currentCheckValuetion = item.code;
      dataMap.factorChildrenList = item.children || [];
    }


    const getParams = () => {
      
      const zfObj = (dataMap.rangeCheckList || []).find((item:any) => item.parentCode === 'zf') || {};
      const hslObj = (dataMap.rangeCheckList || []).find((item:any) => item.parentCode === 'hsl') || {};
      const lzbObj = (dataMap.rangeCheckList || []).find((item:any) => item.parentCode === 'lzb') || {};
      const ljbObj = (dataMap.rangeCheckList || []).find((item:any) => item.parentCode === 'ljb') || {};
      
      const params = []
      if( zfObj['minValue'] || zfObj['maxValue'] ){
        if( zfObj['type'] === 'custom' ){
          params.push({
            type: '1',
            symbol: '<=',
            num: zfObj['maxValue'],
          })
          params.push({
            type: '1',
            symbol: '>=',
            num: zfObj['minValue'],
          })
        }else{
          params.push({
            type: '1',
            symbol: zfObj['maxValue'],
            num: zfObj['minValue'],
          })
        }
      }
      if( hslObj['minValue'] || hslObj['maxValue'] ){
        if( hslObj['type'] === 'custom' || hslObj['type'] === 'c' ){
          params.push({
            type: '2',
            symbol: '<=',
            num: hslObj['maxValue'],
          })
          params.push({
            type: '2',
            symbol: '>=',
            num: hslObj['minValue'],
          })
        }else{
          params.push({
            type: '2',
            symbol: hslObj['maxValue'],
            num: hslObj['minValue'],
          })
        }
      }
      if( lzbObj['minValue'] || lzbObj['maxValue'] ){
        if( lzbObj['type'] === 'custom' ){
          params.push({
            type: '3',
            symbol: '<=',
            num: lzbObj['maxValue'],
          })
          params.push({
            type: '3',
            symbol: '>=',
            num: lzbObj['minValue'],
          })
        }else{
          params.push({
            type: '3',
            symbol: lzbObj['maxValue'],
            num: lzbObj['minValue'],
          })
        }
      }
      if( ljbObj['minValue'] || ljbObj['maxValue'] ){
        if( ljbObj['type'] === 'custom' ){
          params.push({
            type: '4',
            symbol: '<=',
            num: ljbObj['maxValue'],
          })
          params.push({
            type: '4',
            symbol: '>=',
            num: ljbObj['minValue'],
          })
        }else{
          params.push({
            type: '4',
            symbol: ljbObj['maxValue'],
            num: ljbObj['minValue'],
          })
        }
      }

      return params;
    }

    const changeCustomValue = (e:any, type:String) => {
      const reg = /^-?(0|([1-9][0-9]*))(\.[\d]{1,2})?$/; 
      const result = reg.test(e);
      if(type === 'value1'){
        dataMap.isVaild1 = !result;
      }else {
        dataMap.isVaild2 = !result;
      }
      if(!dataMap.customValue1 && !dataMap.customValue2){
        dataMap.isDisabled = true;
      }else{
        if(dataMap.customValue1 && !dataMap.isVaild1 && dataMap.customValue2 && dataMap.isVaild2){
          dataMap.isDisabled = true;
        }else if(dataMap.customValue1 && dataMap.isVaild1 && dataMap.customValue2 && !dataMap.isVaild2){
          dataMap.isDisabled = true;
        }else if(dataMap.customValue1 && dataMap.isVaild1 && !dataMap.customValue2){
          dataMap.isDisabled = true;
        }else{
          dataMap.isDisabled = false;
        }
      }
    }

    // 搜索
    const onSearch = (item:any) => {
      console.log(getParams())
      // const params = {
      //   ...getParams(),

      // }
      context.emit('search', getParams())
    }



    return {
      ...toRefs(dataMap),
      factorDataList,
      sortTable,
      delChildrenRange,
      delIndustryTab,
      saveCustomValue,
      checkChildrenRange,
      changeFactorType,
      changeCustomValue,
      onSearch
    }
  }
})
